module.exports = __webpack_public_path__ + "img/rightarrow.e81210ab.svg";